module.exports = __webpack_public_path__ + "0.1.0/img/user_avatar.b4cd37fe.png";